<template>
  <NotificationComponent :description="$t('notification_overdue_invoice')" v-bind="$attrs">
    <template #ctaContent>
      <div class="tw:shrink-0">
        <BaseLinkButton size="medium" class="tw:w-full tw:font-bold tw:text-blue-800" @click="openInvoices">
          <span>{{
            hasAdminOrSupport ? $t('notification_invoice_cta') : $t('log_in_admin_invoice')
          }}</span>
        </BaseLinkButton>
      </div>
    </template>
  </NotificationComponent>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import NotificationComponent from './NotificationComponent.vue'
import BaseLinkButton from '@/components/base/buttons/BaseLinkButton.vue'

import { useInvoicesFilters } from '@/components/billing/invoices/useInvoicesFilters'
import { useSessionValues } from '@/composables/useSessionValues'

const { selectedProductValues, timeframeValue, selectedStatusValues, setStartDate, setEndDate } = useInvoicesFilters()

const router = useRouter()
const store = useStore()
const { hasAdminOrSupport } = useSessionValues()
defineProps({
  extraParameters: {
    type: [Object, null],
    required: true,
    default: null,
  },
})

const openInvoices = () => {
  if (hasAdminOrSupport.value) {
    selectedStatusValues.value = selectedProductValues.value = [
      { id: 'overdue', label: 'tbs_invoice_payment_overdue', value: 'OVERDUE' },
    ]
    selectedProductValues.value = [{ id: 0, label: 'campaign_subscription_status_all', value: 'all' }]
    timeframeValue.value = { id: 'last-12-months', label: 'last_12_months', value: '12' }
    setStartDate({ id: 'last-12-months', label: 'last_12_months', value: '12' })
    setEndDate()
    router.push({ name: 'billing-invoices' })
  } else {
    store.dispatch('session/logout', '/billing/invoices/?loginAsAdmin=true')
  }
}
</script>
